export const PaginationSkeleton = () => (
    <div className="flex items-center justify-center space-x-2">
        <div className="w-8 h-8 bg-gray-200 rounded"></div>
        <div className="w-16 h-8 bg-gray-200 rounded"></div>
        <div className="w-8 h-8 bg-gray-200 rounded"></div>
    </div>
);